// Reusable validation rules for the contact form
// Each rule returns an error string or null

const rules = {
  companyName: (value) => {
    if (!value.trim()) return 'Company name is required';
    if (value.trim().length < 2) return 'Company name must be at least 2 characters';
    if (!/^[a-zA-Z0-9\s.,&'-]+$/.test(value.trim())) return 'Company name contains invalid characters';
    return null;
  },

  contactName: (value) => {
    if (!value.trim()) return 'Contact name is required';
    if (value.trim().length < 2) return 'Name must be at least 2 characters';
    if (!/^[a-zA-Z\s]+$/.test(value.trim())) return 'Only letters and spaces are allowed';
    return null;
  },

  email: (value) => {
    if (!value.trim()) return 'Email address is required';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) return 'Enter a valid email address';
    return null;
  },

  phone: (value) => {
    if (!value.trim()) return 'Phone number is required';
    if (!/^\+?[\d\s\-().]{7,20}$/.test(value.trim())) return 'Enter a valid phone number';
    return null;
  },

  country: (value) => {
    if (!value.trim()) return 'Country / Region is required';
    if (value.trim().length < 2) return 'Please enter a valid country';
    return null;
  },

  inquiryType: (value) => {
    if (!value) return 'Please select an inquiry type';
    return null;
  },

  message: (value) => {
    if (!value.trim()) return 'Message is required';
    if (value.trim().length < 10) return 'Message must be at least 10 characters';
    return null;
  },
};

// Validate a single field
export const validateField = (name, value) => {
  return rules[name] ? rules[name](value) : null;
};

// Validate all fields, returns errors object
export const validateAll = (formData) => {
  const errors = {};
  Object.keys(rules).forEach((field) => {
    const error = rules[field](
      field === 'inquiryType' ? formData[field] : formData[field] ?? ''
    );
    if (error) errors[field] = error;
  });
  return errors;
};
